import React from "react";
import { Typography } from "@material-ui/core";
import { useQuestionGroupPreview } from "../../queries";
import type { PreviewAttrs } from "../../api";
import { RevealedQuestions } from "./ResolvedComponents";
import { PatientPreviewShell } from "./PatientPreviewShell";
import LinkifiedText from "./LinkifiedText";
import { previewStyles as styles } from "./previewStyles";

const QuestionGroupPreview: React.VFC<{
  id: number;
  isExpanded: boolean;
  onToggleExpand: () => void;
  attrs: PreviewAttrs;
  onAttrsChange: (attrs: PreviewAttrs) => void;
}> = ({ id, isExpanded, onToggleExpand, attrs, onAttrsChange }) => {
  const { data: previewData, isLoading, error } = useQuestionGroupPreview(id, attrs);

  return (
    <PatientPreviewShell
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      isLoading={isLoading}
      error={error}
      attrs={attrs}
      onApplyAttrs={onAttrsChange}
    >
      {previewData?.question_group && (
        <div className={styles.preview}>
          {previewData.question_group.title && (
            <Typography variant="h6" className={styles.pageTitle}>
              {previewData.question_group.title}
            </Typography>
          )}
          {previewData.question_group.description && (
            <Typography variant="body2" className={styles.groupDescription}>
              <LinkifiedText text={previewData.question_group.description} />
            </Typography>
          )}
          <RevealedQuestions questions={previewData.question_group.questions} />
        </div>
      )}
    </PatientPreviewShell>
  );
};

export default QuestionGroupPreview;
